import React from 'react';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Radio,
  RadioGroup,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { TipoOperacaoSocietario } from '../../../../../hooks/useSocietario';
import { IWizardFormValues } from '../schema';

export const StepTipoOperacao = () => {
  const { control, formState } = useFormContext<IWizardFormValues>();

  return (
    <Box>
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        Qual operação você quer gerar?
      </Text>

      <Controller
        control={control}
        name="tipo_operacao"
        render={({ field }) => (
          <FormControl mb={5} isInvalid={!!formState.errors.tipo_operacao}>
            <FormLabel fontWeight="bold">Tipo</FormLabel>
            <RadioGroup
              value={field.value}
              onChange={val => field.onChange(val as TipoOperacaoSocietario)}
            >
              <SimpleGrid columns={{ base: 1, md: 2 }} gap={3}>
                <Box
                  borderWidth="1px"
                  borderColor={field.value === 'constituicao' ? 'primary' : 'gray.200'}
                  borderRadius="md"
                  p={4}
                >
                  <Radio value="constituicao">
                    <Box>
                      <Text fontWeight="bold">Constituição</Text>
                      <Text fontSize="sm" color="gray.600">
                        Criação de uma nova sociedade — LTDA, Holding (proteção patrimonial) ou SCP
                        (Sociedade em Conta de Participação). A natureza é escolhida no passo
                        Empresa.
                      </Text>
                    </Box>
                  </Radio>
                </Box>
                <Box
                  borderWidth="1px"
                  borderColor={field.value === 'alteracao' ? 'primary' : 'gray.200'}
                  borderRadius="md"
                  p={4}
                >
                  <Radio value="alteracao">
                    <Box>
                      <Text fontWeight="bold">Alteração</Text>
                      <Text fontSize="sm" color="gray.600">
                        Alteração contratual de sociedade existente
                      </Text>
                    </Box>
                  </Radio>
                </Box>
                <Box
                  borderWidth="1px"
                  borderColor={field.value === 'transformacao' ? 'primary' : 'gray.200'}
                  borderRadius="md"
                  p={4}
                >
                  <Radio value="transformacao">
                    <Box>
                      <Text fontWeight="bold">Transformação</Text>
                      <Text fontSize="sm" color="gray.600">
                        Empresário Individual em Sociedade Limitada
                      </Text>
                    </Box>
                  </Radio>
                </Box>
              </SimpleGrid>
            </RadioGroup>
            <FormErrorMessage>{formState.errors.tipo_operacao?.message}</FormErrorMessage>
          </FormControl>
        )}
      />

      {/* Campo "Contrato vigente (ID)" (contrato_pai_id) removido: a fonte de verdade do
          vigente é o UPLOAD no step "Contrato vigente" (Pós-Fase 6). O campo não era usado
          e o `isRequired` só exibia um `*` enganoso. Ver schema.ts (contrato_pai_id nullable). */}
    </Box>
  );
};

export default StepTipoOperacao;
